import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import { downloadCSV, fetchDataCallOnInitialLoad } from "../../../common_nextgen/utils/UtilFunctions";

const useProcessorFeeTable = () => {
  const { axios_helper_no_header } = useAxios();

  const location = useLocation();
  const stateVal = location.state || [];

  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  const {
    paramsData: initialParamsData = {
      pf3ProcFeeTable: "",
    },
  } = currentState;

  const [data, setData] = useState([]);
  const [paramsData, setParamsData] = useState(initialParamsData);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();

  const [isHideConfirmationModalOpen, setIsHideConfirmationModalOpen] = useState(false);
  const [lookupType, setLookupType] = useState("");
  const [selectParams, setSelectParams] = useState([]);
  const [selectMode, setSelectMode] = useState(false);
  const openHideConfirmationModal = () => setIsHideConfirmationModalOpen(true);

  const {
    PROCESSOR_FEE_TABLE_ADD,
    PROCESSOR_FEE_TABLE_EDIT,
    PROCESSOR_FEE_TABLE_DISPLAY,
    COPY_PROCESSOR_FEE_TABLE,
  } = ROUTE_PATHS;

  const screen_title = "Processor Fee Table";
  const screenNumber = selectMode ? "RCPF3005" : "RCPF3001";

  const formFields = [
    {
      fieldLabel: "PF3 Proc Fee Table",
      name: "pf3ProcFeeTable",
      label: "Table",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
  ];

  const leftButtons = selectMode ? [{
    button_label: "Back",
    button_handeler: () => {
      if (lookupType === "external") {
        const message = { type: "hideModal" };
        window.parent.postMessage(message, "*");
      }
    },
    button_key: "F12",
  }] : [];

  const ctaButtons = [
    ...(!selectMode && [{
      button_label: "Add Processor Fee Table",
      button_handeler: () => {
        navigateToPage(PROCESSOR_FEE_TABLE_ADD, [
          {
            selectedSchedules: selectedRows.length ? selectedRows : [rowData],
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      },
      button_key: "F6",
    }] || []),
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    }
  ]

  const menuOptions = [...(selectMode && [{
    label: "Select",
    icon: <span className="material-icons">add</span>,
    command: async () => {
      try {
        const paramDataMap = new Map();
        selectParams.forEach((key) => {
          if (rowData.hasOwnProperty(key["target"])) {
            paramDataMap.set(key["source"], rowData[key["target"]]);
          }
        });
        const paramData = Object.fromEntries(paramDataMap);

        if (lookupType === "external") {
          const message = {
            type: "responseData",
            data: paramData,
          };
          window.parent.postMessage(message, "*");
        }
      } catch (error) {
        console.error(error);
      }
    }
  }] || [{
    label: "Edit",
    icon: <span className="material-icons">edit</span>,
    command: () => {
      const selectedSchedulesCount = selectedRows.length;
      const { pf3ProcFeeTable } = selectedSchedulesCount
        ? selectedRows[selectedSchedulesCount - 1]
        : rowData;
      navigateToPage(PROCESSOR_FEE_TABLE_EDIT, [
        ...previousState,
        {
          ...currentState,
          paramsData: { ...paramsData, pf3ProcFeeTable: pf3ProcFeeTable },
        },
        {
          selectedSchedules: selectedRows.length ? selectedRows : [rowData],
          previousScreen: location.pathname,
          currentIndex: 0,
        },
      ]);
    }
  },
  {
    label: "Copy",
    icon: <span className="material-icons">content_copy</span>,
    command: () => {
      const selectedSchedulesCount = selectedRows.length;
      const { pf3ProcFeeTable } = selectedSchedulesCount
        ? selectedRows[selectedSchedulesCount - 1]
        : rowData;
      navigateToPage(COPY_PROCESSOR_FEE_TABLE, [
        ...previousState,
        {
          ...currentState,
          paramsData: { ...paramsData, pf3ProcFeeTable: pf3ProcFeeTable },
        },
        {
          selectedPriceSchedules: selectedRows.length
            ? selectedRows
            : [rowData],
          previousScreen: location.pathname,
        },
      ]);
    },
  },
  {
    label: "Delete",
    icon: <span className="material-icons">delete</span>,
    command: () => {
      openConfirmationModal();
    },
  }]
  ),
  {
    label: "Display",
    icon: <span className="material-icons">visibility</span>,
    command: () => {
       if (lookupType === "external") {
        const message = {
          type: "navigateData",
          data: { ...rowData },
          target: "PROCESSOR_FEE_TABLE_READ_ONLY",
        };
        console.log("display message", message);
        return window.parent?.postMessage(message, "*");
      }
      const selectedSchedulesCount = selectedRows.length;
      const { pf3ProcFeeTable } = selectedSchedulesCount
        ? selectedRows[selectedSchedulesCount - 1]
        : rowData;
      navigateToPage(PROCESSOR_FEE_TABLE_DISPLAY, [
        ...previousState,
        {
          ...currentState,
          paramsData: { ...paramsData, pf3ProcFeeTable: pf3ProcFeeTable },
        },
        {
          selectedSchedules: selectedRows.length ? selectedRows : [rowData],
          previousScreen: location.pathname,
          currentIndex: 0,
        },
      ]);
    },
  }
    ];


  if (rowData["hiddenRecordIndicator"] === "Active" && !selectMode) {
    menuOptions.push({
      label: "Hide",
      icon: <span className="material-icons">visibility_off</span>,
      command: () => {
        openHideConfirmationModal();
      },
    });
  }

  const columnDef = [
    {
      header: "Table",
      field: "pf3ProcFeeTable",
    },
    {
      header: "Description",
      field: "pf3ProcFeeTableDesc",
    },
  ];

  const parmKey = "pf3ProcFeeTable";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/pf3ProcessorFeTable`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  useEffect(() => {
    fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, lookupType]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      const params = { pf3ProcFeeTable: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/pf3ProcessorFeTable", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ ...paramsData, screenNumber });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/pf3ProcessorFeTable/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;
    console.log("iframe load", type, data);
    if (type === "initData") {
      const { selectMode, data: paramData } = data;
      console.log("external data", paramData, selectMode);
      setLookupType("external");
      setSelectParams(paramData.params);
      setParamsData(paramData.paramsData);
      setSelectMode(selectMode)
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  return {
    screenNumber,
    screen_title,
    formFields,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deletePriceSchedule,
    setSelectedOption,
    selectMode,
    leftButtons
  };
};

export default useProcessorFeeTable;